export default {
  name: 'dashify:Counter',
  title: 'Counter',
  owner: 'System',
  solution: '',
  tags: ['widget', 'counter'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    props: {
      count: 0,
    },
    onLoad: '/${ function () { $set("/count", props.count) }}',
    count: 0,
    derived: '/${ count * 10}',
    view: [
      ['p', { '.': 'p-2' }, '/${ "count is " & count}'],
      ['p', { '.': 'p-2' }, '/${ "derived state " & derived}'],
      [
        'button',
        {
          '.': 'btn',
          type: 'text',
          onClick: "/${ function() { $set('/count', count+1) } }",
        },
        'Increment',
      ],
      [
        'button',
        {
          '.': 'btn',
          type: 'text',
          onClick: "/${ function() { $set('/count', count-1) } }",
        },
        'Decrement',
      ],
    ],
  },
};
